export default __webpack_public_path__ + "static/media/sentChatIcon.386dea35.svg";